import createStatus from 'src/utils/statuses'

export const DRAFT_ID = 'draft'
export const IN_REVIEW_ID = 'in-review'
export const APPROVED_ID = 'approved'

const DRAFT = {
  id: DRAFT_ID,
  title: 'Draft',
  transition: [DRAFT_ID, IN_REVIEW_ID],
}

const IN_REVIEW = {
  id: IN_REVIEW_ID,
  title: 'In Review',
  transition: [IN_REVIEW_ID, APPROVED_ID],
}

const APPROVED = {
  id: APPROVED_ID,
  title: 'Ready for Blitz',
  transition: [APPROVED_ID],
}

export const ALL_IDS = [DRAFT_ID, IN_REVIEW_ID, APPROVED_ID]

export const ALL_BY_ID = {
  [DRAFT_ID]: DRAFT,
  [IN_REVIEW_ID]: IN_REVIEW,
  [APPROVED_ID]: APPROVED,
}

export const ALL = ALL_IDS.map(id => ALL_BY_ID[id])

export default createStatus(ALL)
